import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import type { FixtureTransformed } from "~pages/Fixtures/types";
import { useApi } from "~shared/api";
import { isDefaultOperationSucceeded } from "~utils/defaultOperationResponse.ts";
import { getFixtureListQueryKey } from "./useFetchAllSeasonFixtures";

export const useDeleteFixture = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const queryClient = useQueryClient();
  const { mutateData } = useApi();
  return useMutation({
    mutationFn: async (fixtureId: string) => {
      return await mutateData({
        url: `${sport}/o/${organizationId}/fixtures/${fixtureId}`,
        method: "DELETE",
      });
    },
    onSuccess: (response: any, fixtureId: string) => {
      if (isDefaultOperationSucceeded(response)) {
        queryClient.setQueryData(getFixtureListQueryKey({ sport, organizationId, seasonId }), (oldFixtures: FixtureTransformed[]) =>
          (oldFixtures || []).filter((x) => x.fixtureId !== fixtureId),
        );
      }
    },
  });
};
